module.exports = __webpack_public_path__ + "img/product2_007FFF_quota.233d9c2e.png";